import { render, staticRenderFns } from "./BasicSensor.vue?vue&type=template&id=bc815c86&scoped=true&"
import script from "./BasicSensor.vue?vue&type=script&lang=js&"
export * from "./BasicSensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc815c86",
  null
  
)

export default component.exports